import React from 'react';
import { ConfirmPopup } from './../../../common/popup';
import { connect } from 'react-redux';
import { REDUCER_NAME, showHideExcel } from './../reducer';
import { I18n } from 'react-redux-i18n';

class ExcelPopup extends React.Component {
  render() {
    const { isShow, showHideExcel } = this.props;

    return (
      <ConfirmPopup
        title={I18n.t('layout.notComeOut.title')}
        messages={[I18n.t('layout.notComeOut.message')]}
        isShow={isShow}
        enabledCancel={false}
        enabledApply={false}
        confirm={showHideExcel}
        iconName={'icon-warning'}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    isShow: state[REDUCER_NAME].excel.isShow,
  };
};

const mapDispatchToProps = {
  showHideExcel,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExcelPopup);
